import {
  SET_USER_LOADING,
  SET_USER,
  SET_AUTH_ERROR,
  CLEAR_AUTH_ERROR,
  LOGOUT_USER,
  CLEAR_SESSION,
  SET_COOKIE_PREF,
  SET_PROVIDER_EDITING,
  SET_PROVIDER,
  SET_MEMBERSHIPS,
} from '../actions/userAuthActions';

const getInitialState = () => {
  const cookiePref =
    typeof window !== 'undefined' && window.localStorage.getItem('cookiePref')
      ? window.localStorage.getItem('cookiePref')
      : null;

  return {
    userLoading: true,
    user: {},
    error: '',
    cookiePref,
    isEditingProvider: false,
  };
};

export const userAuthReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case SET_USER_LOADING:
      return { ...state, userLoading: true };
    case SET_USER: {
      const nextState = { ...state, userLoading: false, user: action.payload, error: '' };
      if (Array.isArray(action.payload?.memberships)) {
        nextState.memberships = action.payload.memberships;
      } else if ('memberships' in state && !action.payload?.email) {
        nextState.memberships = [];
      }
      return nextState;
    }
    case SET_MEMBERSHIPS:
      return {
        ...state,
        memberships: action.payload,
        user: state.user?.email ? { ...state.user, memberships: action.payload } : state.user,
      };
    case SET_AUTH_ERROR:
      return { ...state, userLoading: false, error: action.payload };
    case CLEAR_AUTH_ERROR:
      return { ...state, error: '' };
    case LOGOUT_USER: {
      const nextState = { ...state, userLoading: false, user: {}, error: '' };
      if ('memberships' in state) nextState.memberships = [];
      return nextState;
    }
    case CLEAR_SESSION: {
      const nextState = { ...state, userLoading: false, user: {}, error: '' };
      if ('memberships' in state) nextState.memberships = [];
      return nextState;
    }
    case SET_COOKIE_PREF:
      return { ...state, cookiePref: action.payload };
    case SET_PROVIDER:
      return {
        ...state,
        user: { ...state.user, provider: action.payload },
      };
    case SET_PROVIDER_EDITING:
      return { ...state, isEditingProvider: action.payload };
    default:
      return state;
  }
};
